import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustedBy from "../components/TrustedBy";
import Features from "../components/Features";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import { TooltipProvider } from "../components/common/CustomTooltip";

export default function Home() {
  return (
    <>
      <TooltipProvider>
        <Navbar />
        <Hero />
        {/* <TrustedBy />
        <Features />
        <CTA />
        <Footer /> */}
      </TooltipProvider>
    </>
  );
}